import React from 'react'

export default function DrawArea({ path, strokeColor, strokeWidth }) {
  if (path.length < 2) return null
  const firstPoint = path[0]
  const lastPoint = path[path.length - 1]

  const d = `M ${firstPoint.x} ${firstPoint.y} L ${lastPoint.x} ${firstPoint.y} L ${lastPoint.x} ${lastPoint.y} L ${firstPoint.x} ${lastPoint.y} z`

  return (
    <path
      d={d}
      fill="transparent"
      stroke={strokeColor || 'red'}
      strokeWidth={strokeWidth || 2}
    />
  )
}
